import { UnwrapRef } from 'vue';
import { _StoreWithState, _StoreWithGetters, PiniaCustomProperties } from 'pinia';
import {
  AppointmentInterface,
  AppointmentStateInterface,
  StatusType
} from './state';
import { AppointmentsGetters } from './getters';
import {
  bookAppointment,
  appointmentsRead,
  appointmentsList,
  appointmentsHistoryList,
  appointmentsUpdate,
  accelerateAppointment
} from 'src/services/functions';
import mixpanel from 'mixpanel-browser';
type AppointmentsActions = {
  read(code: string, identifier: string): Promise<AppointmentInterface>;
  get(): Promise<AppointmentInterface[]>;
  getHistory(): Promise<AppointmentInterface[]>;
  updateStatus(
    id: string,
    identifier: string,
    status: StatusType
  ): Promise<void>;
  book(payload: BookPayload): Promise<string>;
  accelerate(payload: BookPayload, appointmentId: string ): Promise<string>
};

interface BookPayload {
  patientIdentifier: string;
  service: string;
  specialty: string;
  slots: string[];
  comment: string;
  'attention-type': string;
}

const actions: AppointmentsActions &
  ThisType<
    AppointmentsActions &
      UnwrapRef<AppointmentStateInterface> &
      _StoreWithState<
        string,
        AppointmentStateInterface,
        AppointmentsGetters,
        AppointmentsActions
      > &
      _StoreWithGetters<AppointmentsGetters> &
      PiniaCustomProperties
  > = {
  async read(code: string, identifier: string) {
    return appointmentsRead(code, identifier).then(appointment => {
      return appointment;
    });
  },
  async get() {
    return appointmentsList().then((result: AppointmentInterface[]) => {
      this.list = result;
      return result;
    });
  },
  async getHistory() {
    return appointmentsHistoryList().then((result: AppointmentInterface[]) => {
      this.history = result;
      return result;
    });
  },
  async updateStatus(id: string, identifier: string, status: StatusType) {
    return appointmentsUpdate(id, identifier, status).then(() => {
      const app = this.list.find(el => el.id === id);
      if (app) {
        app.status = status;
        mixpanel.track('Appointment status updated', {
          status: status,
          specialty: app.specialty?.find((sp) => sp.extension?.find((ex) => ex.url === 'user-selected' && ex.valueBoolean))?.text || '',
        })
      }
    });
  },
  async book(payload: BookPayload) {
    return bookAppointment(payload).then(result => {
      this.list.push(result);
      mixpanel.track('Appointment book', {
        specialty: payload.specialty,
      })
      return String(result.id);
    });
  },
  async accelerate(payload, appointmentId) {
    return accelerateAppointment(payload, appointmentId)
      .then((result) => {
        this.list.push(result);
        mixpanel.track('Appointment accelerate', {
          specialty: payload.specialty,
        })
        const app = this.list.find(el => el.id === appointmentId);
        if (app) {
          app.status = 'cancelled'
          mixpanel.track('Appointment accelerate-cancel', {
            status: 'cancelled',
            specialty: app.specialty?.find((sp) => sp.extension?.find((ex) => ex.url === 'user-selected' && ex.valueBoolean))?.text || '',
          })
        }
        return String(result.id);
      })
  }
};

export default actions;
